// extracted by mini-css-extract-plugin
module.exports = {"bg":"_2_Yqp_EjRIPV_8TeJT6Ocy","sideNav":"J5U9Qz2PX5VvzD-CpA9Kv","header":"mo8ru-vQNbqH4i7h2xRYW","logo":"_3a0GXA8TZE5zf_5kOyx9fS"};